// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import Version from '../data/version.txt';

export class Footer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            version: ""
        }

        this.getVersion()
    }

    getVersion() {
        fetch(Version)
            .then(response => response.text())
            .then(versionText => {
                let v = versionText.split('\n')[0]
                console.log("Version: " + v)

                this.setState({
                    version: "Last updated: " + v
                })
            });
    }

    render() {
        if (!window.sessionStorage.getItem('authToken')) {
            return (
                <footer>
                    <section>
                        <p>Copyright © Enabler Interactive Pty Ltd</p>
                        <p>{this.state.version}</p>
                    </section>
                </footer>
            )
        }
        else {
            return (
                <footer>
                </footer>
            )
        }
    }
}




// WEBPACK FOOTER //
// ./src/components/footer.js